module.exports = __webpack_public_path__ + "static/img/baosongliucheng.53adeeae.png";